import type { Les } from '../types';

export interface LesBadge {
  tekst: string;
  kleur: 'changed' | 'cancelled' | 'new' | 'exam';
}

/** Alleen gestructureerde status en wijzigingsvelden bepalen de pillen. */
export function badgesVoorLes(les: Pick<Les, 'status' | 'wijzigingen'>): LesBadge[] {
  const badges: LesBadge[] = [];
  if (les.status === 'cancelled') badges.push({ tekst: 'VERVALLEN', kleur: 'cancelled' });
  if (les.status === 'new') badges.push({ tekst: 'NIEUW · EXTRA INGEPLAND', kleur: 'new' });
  if (les.status === 'exam') badges.push({ tekst: 'TOETS', kleur: 'exam' });

  const labels = { lokaal: 'LOKAALWISSEL', uur: 'TIJDWIJZIGING', docent: 'DOCENTWISSEL' } as const;
  for (const veld of ['lokaal', 'uur', 'docent'] as const) {
    if (les.wijzigingen.some((wijziging) => wijziging.veld === veld)) {
      badges.push({ tekst: labels[veld], kleur: 'changed' });
    }
  }
  return badges;
}
